import { ListingType, PROPERTY_GRID_SUBJECT_PROPERTY, syntaxFNMA } from '@aloft/toolkit-shared';
import { Flex, Icon, theme } from '@aloft/toolkit-sui';

import { Control, useWatch } from 'react-hook-form';

import { getColorForStatusOrSubject } from '../../../utils/getColorForStatusOrSubject.ts';
import { PropertyHeader } from '../../PropertyHeader/PropertyHeader.tsx';
import { ValuationTablePropertyHeaderColorBand } from '../../PropertyHeader/internal/ValuationTablePropertyHeaderColorBand.tsx';
import { PROPERTY_HEADER_TOTAL_HEIGHT } from '../consts.ts';
import { PropertyGridForm, PropertyGridType } from '../types.ts';
import { getDataSourceDisplayInfo } from '../utils.ts';

type HeaderPropertyGridSectionProps = {
  columnIndex: number;
  gridType: PropertyGridType;
  control: Control<PropertyGridForm>;
  dataSourceDrawerEnabled: boolean;
  listingType?: ListingType;
};

export const HeaderPropertyGridSection = ({
  columnIndex,
  gridType,
  control,
  dataSourceDrawerEnabled,
  listingType,
}: HeaderPropertyGridSectionProps) => {
  const columnData = useWatch({ control, name: `columns.${columnIndex}` });

  const { propertyData, type, propertyId } = columnData ?? {};

  const transaction = propertyData?.editableData?.transaction;

  if (type === 'property' && (!propertyData || !transaction)) return null;

  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;
  let propertyStatus:
    | syntaxFNMA.UadListingStatus
    | syntaxFNMA.RentalListingStatus
    | 'Off-Market'
    | 'Subject' = 'Subject';

  if (!isSubject) {
    propertyStatus =
      listingType === 'rentalListing'
        ? (transaction?.rentalListingStatus ?? 'Off-Market')
        : (transaction?.status ?? 'Off-Market');
  }
  const color = getColorForStatusOrSubject(propertyStatus);
  const hideActions = gridType === 'SensitivityGrid';
  const hideMoreMenu = gridType === 'AdjustmentsGrid';

  if (type === 'property') {
    return (
      <Flex
        flexDirection="column"
        position="sticky"
        top="0"
        zIndex={theme.zIndices.sticky}
        __dangerDoNotUseSx={{ borderTop: `1px solid ${theme.colors.strokeDefault}` }}
      >
        <PropertyHeader
          propertyId={propertyId}
          gridType={gridType}
          showDataSourceDrawerToggler={dataSourceDrawerEnabled}
          listingType={listingType}
          hideActions={hideActions}
          hideMoreMenu={hideMoreMenu}
        />
      </Flex>
    );
  }

  const { icon, text } = getDataSourceDisplayInfo(type);

  return (
    <Flex
      flexDirection="column"
      position="sticky"
      top="0"
      zIndex={theme.zIndices.sticky}
      alignItems="center"
      __dangerDoNotUseSx={{
        borderTop: `1px solid ${theme.colors.strokeDefault}`,
        color: theme.colors.buttonDefault,
      }}
    >
      <Flex
        flexDirection="column"
        width="100%"
        height={PROPERTY_HEADER_TOTAL_HEIGHT}
        backgroundColor="surface1"
      >
        <Flex flexDirection="column" alignItems="center" justifyContent="center" flexGrow={1}>
          <Icon size="xl" icon={icon} color="buttonDefault" />
          {text}
        </Flex>
        <ValuationTablePropertyHeaderColorBand color={color} />
      </Flex>
    </Flex>
  );
};
